import { jsx as _jsx } from "react/jsx-runtime";
import { useParams, useSearchParams } from "react-router-dom-v5-compat";
import { OrderFlow_V2 } from "./OrderFlow_V2";
export const EditFlow = () => {
    var _a, _b, _c, _d;
    // path params (sku)
    const pathParams = useParams();
    // query string params
    const [searchParams] = useSearchParams();
    return (_jsx(OrderFlow_V2, { sku: pathParams.sku, editOrderId: (_a = searchParams.get("orderId")) !== null && _a !== void 0 ? _a : undefined, dateChangesTakeEffect: (_b = searchParams.get("dateChangesTakeEffect")) !== null && _b !== void 0 ? _b : undefined, subscriptionLinkId: (_c = Number(searchParams.get("subscriptionLinkId"))) !== null && _c !== void 0 ? _c : undefined, startDate: (_d = searchParams.get("startDate")) !== null && _d !== void 0 ? _d : undefined, 
        // There is no modal to close when EditFlow is a route
        closeEditModal: undefined }));
};
